import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactGA from 'react-ga';
import {
  MAX_FEED_DESCRIPTION_LENGTH_TO_SHOW_BY_DEFAULT,
  SARCASTIC_PILL_CLASS,
  SARCASTIC_COMMENT_COUNT_LABEL,
  SARCASTIC_COMMENT_COUNT_HOVER_TEXT,
  RELEVANT_COMMENT_PILL_CLASS,
  RELEVANT_COMMENT_COUNT_LABEL,
  RELEVANT_COMMENT_COUNT_HOVER_TEXT,
  ALL, CONVERT_KEYWORDS_JSON_TO_LIST_TO_USE_FOR_HIGHLIGHTING_MATCHING_TEXT,
  MARKED_AS_IRRELEVANT_LABEL
} from '../redux/constants';
import {
  capitalizeWords,
  getFeedIconForFacebook, getFeedIconForInstagram,
  getFeedIconForReddit,
  getFeedIconForYoutube,
  getFeedIconForTiktok,
  getFeedIconForForum
} from '../sharedFunctions';
import { IS_SARCASM_ENABLED } from '../../../common/globalConstants';
import RelevanceCard from './comment-toggle/RelevanceCard';
import {
  FACEBOOK_PAGE_CSS_CLASS_NAME,
  FACEBOOK_PAGE_IN_SOURCE_NAME, INSTAGRAM_KEY,
  REDDIT_KEY,
  YOUTUBE_KEY,
  TIKTOK_SOURCE_NAME,
  TIKTOK_KEY,
  FORUM_KEY
} from './constants/FeedCommentConstants';

const DECIMAL_PLACES_TO_DISPLAY_LARGER_NUMBERS = 1;
const PARSE_INT_RADIX = 10;

export class Feeds extends Component {
  static propTypes = {
    feed: PropTypes.object.isRequired,
    cookies: PropTypes.object,
    handleFeedDetails: PropTypes.func,
    updateRelevanceFeed: PropTypes.func,
    topicKeywordsJSON: PropTypes.object,
    isHarmWatchTab: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      feed: {
        isTranslated: false,
        feedTitleInOriginalLanguage:"",
        feedMessageInOriginalLanguage:"",
        feedDescriptionInOriginalLanguage:"",
        feedDescription: "",
        feedTitle: "",
        feedMessage: "",
        feedDatetime: null,
        source: "",
        sourceLink: "",
        sentiment: {
          category: ""
        },
        emotion: {
          category: ""
        },
        sarcasticCommentCount: null,
        relevantCommentCount: null
      },
      currentFeed: {
        feedDescription: "",
        feedTitle: "",
        feedMessage: "",
        feedDatetime: null,
        source: "",
        sourceLink: "",
        sentiment: {
          category: ""
        },
        emotion: {
          category: ""
        },
        sarcasticCommentCount: null,
        relevantCommentCount: null
      },
      updateRelevanceFeed: {},
      isSeeMore: false,
      topicKeywordsJSON: {},
      allTopicKeywords: [],
      isTopicPreview: false,
      isEllipsisActive: false
    };
    this.wrapperRef = React.createRef();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidMount() {
    this.setState({
      feed: this.props.feed,
      currentFeed: this.props.feed,
      updateRelevanceFeed: this.props.updateRelevanceFeed,
      isTopicPreview: this.props.isTopicPreview
    });
    this._updateTopicKeywordsRelatedStateIfNewKeywordsJSON(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      currentFeed: nextProps.feed,
      feed: nextProps.feed,
      updateRelevanceFeed: nextProps.updateRelevanceFeed,
      isTopicPreview: nextProps.isTopicPreview
    });
    this._updateTopicKeywordsRelatedStateIfNewKeywordsJSON(nextProps);
  }

  toggleIfEllipsisIsActive= () => {
    this.setState(prevState => {
      return { isEllipsisActive: !prevState.isEllipsisActive };
    });
  
  }

  handleClickOutside = event => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({isEllipsisActive: false });
    }
  }

  _updateTopicKeywordsRelatedStateIfNewKeywordsJSON(nextProps) {
    if (nextProps.topicKeywordsJSON && this.state.topicKeywordsJSON !== nextProps.topicKeywordsJSON) {
      const allTopicKeywords = CONVERT_KEYWORDS_JSON_TO_LIST_TO_USE_FOR_HIGHLIGHTING_MATCHING_TEXT(nextProps.topicKeywordsJSON);
      this.setState({
        allTopicKeywords: allTopicKeywords,
        topicKeywordsJSON: nextProps.topicKeywordsJSON}
      );
    }
  }

  setRelevance(props) {
    const {
      feed,
      updateRelevanceFeed
    } = this.state;
    const relevance = props.relevance;
    const feedId = parseInt(props.commentOrPostId, PARSE_INT_RADIX);
    if (feed.relevance !== relevance) {
      ReactGA.event(
        {
          category : 'Feeds' ,
          action : 'User with id' + this.props.cookies.userMeta+' set feed with id '+feedId+' as relevant'
        }
      );
      updateRelevanceFeed({ feedId: feedId, relevance: relevance, postId: feed.postId });
    }
    this.setState({
      isEllipsisActive: false
    });
    return false;
  }

  numberConverter(number, decPlaces) {
    decPlaces = Math.pow(10, decPlaces);
    var abbrev = ['K', 'M', 'B', 'T'];
    for (var i = abbrev.length - 1; i >= 0; i--) {
      var size = Math.pow(10, (i + 1) * 3);
      if (size <= number) {
        number = Math.round((number * decPlaces) / size) / decPlaces;
        if (number === 1000 && i < abbrev.length - 1) {
          number = 1;
          i++;
        }
        number += abbrev[i];
        break;
      }
    }
    return number;
  }

  toggleSeeMore = isSeeMore => {
    this.setState({isSeeMore});
  }

  _getFeedCSSName = () => {
    const {currentFeed} = this.state;
    if (currentFeed.source.toLowerCase().includes(FACEBOOK_PAGE_IN_SOURCE_NAME)) {
      return FACEBOOK_PAGE_CSS_CLASS_NAME;
    }
    else {
      return currentFeed.source.toLowerCase();
    }
  }

  _getFeedIcon = () => {
    const {currentFeed} = this.state;
    if (currentFeed.source.toLowerCase().includes(FACEBOOK_PAGE_IN_SOURCE_NAME)) {
      return getFeedIconForFacebook(currentFeed.source);
    }
    else if (currentFeed.source.toLowerCase() == REDDIT_KEY){
      return getFeedIconForReddit(currentFeed.sourceLink);
    }
    else if (currentFeed.source.toLowerCase() == YOUTUBE_KEY){
      return getFeedIconForYoutube();
    }
    else if (currentFeed.source.toLowerCase().includes(INSTAGRAM_KEY)){
      return getFeedIconForInstagram();
    }
    else if (currentFeed.source.toLowerCase().includes(TIKTOK_KEY)){
      return getFeedIconForTiktok();
    }
    else if (currentFeed.source.toLowerCase().includes(FORUM_KEY)){
      return getFeedIconForForum(currentFeed.source);
    }
    else {
      return currentFeed.source.toLowerCase();
    }
  }

  _hasDescription = () => {
    return (this.state.currentFeed && this.state.currentFeed.feedDescription);
  }

  _descriptionIsGreaterThanMaxLengthToShowByDefault = () => {
    return (this._hasDescription() && this.state.currentFeed.feedDescription.length > MAX_FEED_DESCRIPTION_LENGTH_TO_SHOW_BY_DEFAULT);
  }

  _convertFeedTextToInnerHTMLWithHighlightedKeywords = (feedText) => {
    let updatedFeedText      = feedText;
    if (updatedFeedText === null) {
      return "";
    }
    const {allTopicKeywords} = this.state;
    allTopicKeywords.sort((a,b) => b.length - a.length);
    for (let keyword of allTopicKeywords) {
        let myRegexp = new RegExp(`(^|[^a-zA-Z0-9])(${keyword})([^a-zA-Z0-9]|$)`,'mig');
          updatedFeedText = updatedFeedText.replace(
            myRegexp,
            '$1<span style="background-color: yellow;">$2</span>$3'
        );
    }
    return updatedFeedText;
  }

  _returnSarcasmCommentCountText = () => {
    const {feed} = this.state;
    if (feed.sarcasticCommentCount !== null) {
      return `${SARCASTIC_COMMENT_COUNT_LABEL}${feed.sarcasticCommentCount}`;
    }
    return '';
  }

  _returnRelevantCommentCountText = () => {
    const {feed} = this.state;
    if (feed.relevantCommentCount !== null) {
      const convertedNumber = this.numberConverter(feed.relevantCommentCount, DECIMAL_PLACES_TO_DISPLAY_LARGER_NUMBERS);
      return `${RELEVANT_COMMENT_COUNT_LABEL}${convertedNumber}`;
    }
    return '';
  }

  renderOriginalLanguageIfItIsTranslated(currentFeed,isSeeMore){
    return  currentFeed.isTranslated && (
      <div className='original-non-english'>
        <div>
            <div className='vertical-line'/>
                <h4
                  dangerouslySetInnerHTML={{ __html: this._convertFeedTextToInnerHTMLWithHighlightedKeywords(currentFeed.feedTitleInOriginalLanguage) }}
                  title={currentFeed.feedTitleInOriginalLanguage}
                />
                <div className='feed-original-content'>
                {currentFeed.feedMessageInOriginalLanguage && (
                    <h5
                        dangerouslySetInnerHTML={{ __html: this._convertFeedTextToInnerHTMLWithHighlightedKeywords(currentFeed.feedMessageInOriginalLanguage) }}
                        title={currentFeed.feedMessageInOriginalLanguage}
                    />
                )}
                  {(currentFeed.feedDescriptionInOriginalLanguage !== currentFeed.feedMessageInOriginalLanguage) && (
                  <p className={`${!isSeeMore ? 'shrink-text-view' : ''}`}
                      dangerouslySetInnerHTML={{ __html: this._convertFeedTextToInnerHTMLWithHighlightedKeywords(currentFeed.feedDescriptionInOriginalLanguage) }}
                  />
                  )}
              </div>
          {(currentFeed.feedDescriptionInOriginalLanguage !== currentFeed.feedMessageInOriginalLanguage) && (
            <span>
              {this._descriptionIsGreaterThanMaxLengthToShowByDefault()  && !isSeeMore ? (
                <span className="see-more-btn" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                  <u>See More</u>
                </span>
              ) : (
                this._descriptionIsGreaterThanMaxLengthToShowByDefault() && isSeeMore && (
                  <span className="see-more-btn less" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                    See Less
                  </span>
                )
              )}
            </span>
            )}
          </div>
      </div>
    )
  }

  render() {
    const { 
      currentFeed,
      feed,
      isSeeMore,
      isTopicPreview,
      isEllipsisActive
    } = this.state;
    const feedCSSName          = this._getFeedCSSName();
    const sarcasmCommentCountText  = this._returnSarcasmCommentCountText()
    const relevantCommentCountText = this._returnRelevantCommentCountText()
    return (
        <div className="comment-card feeds">
          <div className="feeds-description">
            <div 
              className="feeds-button"
              ref={this.wrapperRef}
            >
              <div className={`social-button ${feedCSSName}`}>
                <span title={`${capitalizeWords(feedCSSName)}`}>
                  <img src={this._getFeedIcon()} alt=""/> 
                </span>
              </div>
              {!isTopicPreview && (feed.relevantCommentCount !== null) && (currentFeed.source !== TIKTOK_SOURCE_NAME) && (
                <div className="card-header-button">
                  <button 
                    className={`btn-positive ${RELEVANT_COMMENT_PILL_CLASS}`}
                    onClick={() => this.props.handleFeedDetails(ALL)}
                    disabled={this.props.isFeedModal}
                    title={RELEVANT_COMMENT_COUNT_HOVER_TEXT}
                  >
                  {relevantCommentCountText}
                  </button>
                </div>
              )}
              {currentFeed.sentiment.length > 0 && (currentFeed.source !== TIKTOK_SOURCE_NAME) &&
                currentFeed.sentiment.map((sentiments, index) => (
                  <div className="card-header-button" key={index}>
                    <button
                      className={`btn-${sentiments.category} ${sentiments.category}`}
                      onClick={() => this.props.handleFeedDetails(sentiments.category)}
                      disabled={isTopicPreview || this.props.isFeedModal}
                      title={`Number of ${sentiments.category} comments`}
                    >
                      {this.numberConverter(sentiments.total, DECIMAL_PLACES_TO_DISPLAY_LARGER_NUMBERS)}
                    </button>
                  </div>
                ))}
              {IS_SARCASM_ENABLED && !isTopicPreview && (feed.sarcasticCommentCount !== null) && (currentFeed.source !== TIKTOK_SOURCE_NAME) &&(
                <div className="card-header-button feed-sarcasm-pill">
                  <button className={`btn-emotion ${SARCASTIC_PILL_CLASS}`}
                  title={SARCASTIC_COMMENT_COUNT_HOVER_TEXT}>
                  {sarcasmCommentCountText}
                  </button>
                </div>
              )}
              {!this.props.isHarmWatchTab && (<button 
                className={`ellipsis ${isEllipsisActive ? 'active' : ''}`}
                onClick={() => this.toggleIfEllipsisIsActive()}
                onKeyDown={() => {}}
              >
                <i className="la la-ellipsis-v"></i>
              </button>)}
              {isEllipsisActive && (
                <div 
                  className={`comments-toggle ${this.props.isFeedModal ? 'default-toggle-card-margin' : 'feed-toggle-card-margin'}`}
                >
                  <RelevanceCard
                    userCommentOrPost={this.props.feed}
                    updateRelevance={e => this.setRelevance(e)}
                    commentOrPostId={this.props.feed.feedId}
                  />
                </div>
              )}
            </div>
            <h4
              dangerouslySetInnerHTML={{ __html: this._convertFeedTextToInnerHTMLWithHighlightedKeywords(currentFeed.feedTitle) }}
              title={currentFeed.feedTitle}
            />
            {currentFeed.feedMessage && (
              <h5 style={{ 'fontSize': '12px', 'fontWeight': 'normal', 'color': '#999999' }}
                  dangerouslySetInnerHTML={{ __html: this._convertFeedTextToInnerHTMLWithHighlightedKeywords(currentFeed.feedMessage) }}
                  title={currentFeed.feedMessage}
              />
            )}
            {(currentFeed.feedDescription !== currentFeed.feedMessage) && (
              <p className={`${!isSeeMore ? 'shrink-text-view' : ''}`} style={{'fontStyle':'italic'}}
               dangerouslySetInnerHTML={{ __html: this._convertFeedTextToInnerHTMLWithHighlightedKeywords(currentFeed.feedDescription) }}
            />)}
            {(currentFeed.feedDescription !== currentFeed.feedMessage) && (
              <span>
                {this._descriptionIsGreaterThanMaxLengthToShowByDefault()  && !isSeeMore ? (
                  <span className="see-more-btn" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                    <u>See More</u>
                  </span>
                ) : (
                  this._descriptionIsGreaterThanMaxLengthToShowByDefault() && isSeeMore && (
                    <span className="see-more-btn less" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                      See Less
                    </span>
                  )
                )}
              </span>
            )}
            {this.renderOriginalLanguageIfItIsTranslated(currentFeed,isSeeMore)}
            {feed.relevance ? (
                <br/>
            ) : null}
            <div className={`card-header-bottom ${!feed.relevance ? 'card-header-bottom-space-between feed-marked-as-irrelevant' : ''}`}>
              {!feed.relevance && (
                <div className="card-header-irrelevant">{MARKED_AS_IRRELEVANT_LABEL}</div>
              )}
            </div>
            <div className="footer">
              {! this.props.isFeedModal && this.props.handleFeedDetails && (currentFeed.source !== TIKTOK_SOURCE_NAME) &&(
                <div>
                  <span>
                    <span
                        className="view-comments-for-feed-link"
                        onClick={() => this.props.handleFeedDetails(ALL)}
                      >
                      View Comments
                    </span>
                  </span>
                </div>)}
              <div className="feed-date flex-grow-1">
                <span className="feed-date-text">{moment(currentFeed.feedDatetime).format('DD MMM YYYY hh:mm A')}</span>
              </div>
            </div>
          </div>
        </div>
      )
    }
}

export default Feeds;



// WEBPACK FOOTER //
// ./src/features/home/components/Feeds.js